"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionHint = exports.ActionEvaluator = void 0;
const __1 = require("../");
var ActionHint;
(function (ActionHint) {
    ActionHint["FOLD"] = "FOLD";
    ActionHint["CHECK"] = "CHECK";
    ActionHint["BET"] = "BET";
    ActionHint["RAISE"] = "RAISE";
    ActionHint["CALL"] = "CALL";
    ActionHint["ALLIN"] = "ALLIN";
})(ActionHint || (ActionHint = {}));
exports.ActionHint = ActionHint;
class ActionEvaluator {
    static getActionHints(board, player, bigBlindPlayer) {
        if (board.isPreDeal() || board.isShowdown()) {
            return [];
        }
        const playerBet = player.bets.reduce((overallBet, bet) => {
            overallBet += bet.amount;
            return overallBet;
        }, 0);
        const boardHasBets = board.hasBetsNoChecks();
        const bigBlindCalled = bigBlindPlayer &&
            player.getId() === bigBlindPlayer.getId() &&
            board.biggestBet() === board.blinds.big &&
            playerBet === board.blinds.big;
        const playerCanRaise = player.chips / board.biggestBet() > 1;
        const playerCanCall = player.chips + playerBet - board.biggestBet() > 0;
        const hints = [];
        if (bigBlindCalled) {
            if (playerCanRaise) {
                hints.push(ActionHint.RAISE);
            }
            hints.push(ActionHint.CHECK);
        }
        else if (boardHasBets) {
            if (!playerCanCall) {
                hints.push(ActionHint.ALLIN);
            }
            else {
                if (playerCanRaise) {
                    hints.push(ActionHint.RAISE);
                }
                hints.push(ActionHint.CALL);
            }
            hints.push(ActionHint.FOLD);
        }
        else {
            if (!playerCanCall) {
                hints.push(ActionHint.ALLIN);
            }
            else {
                hints.push(ActionHint.BET);
            }
            hints.push(ActionHint.CHECK);
        }
        if (hints.length === 0) {
            throw Error(__1.Language.strings.error.actions.noActionHintsError);
        }
        return hints;
    }
}
exports.ActionEvaluator = ActionEvaluator;
//# sourceMappingURL=ActionEvaluator.js.map